import PropTypes from 'prop-types';
// @mui
import { Box, Typography, Card, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// components
import Iconify from 'src/components/iconify';
// utils
import { fNumber } from 'src/utils/format-number';

// ----------------------------------------------------------------------

export default function Cards({ title, total, icon, color, sx, ...other }) {
    const theme = useTheme();

    return (
        <Card
            sx={ {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                p: 2,
                width: '100%',
                minHeight: 80,
                boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                borderRadius: 2,
                ...sx,
            } }
            { ...other }
        >
            <Avatar
                sx={ {
                    bgcolor: color || theme.palette.primary.main,
                    width: 32,
                    height: 32,
                    mr: 2,
                } }
            >
                <Iconify icon={ icon } width={ 20 } height={ 20 } />
            </Avatar>

            <Box>
                <Typography variant="subtitle1" noWrap>
                    { title }
                </Typography>
                <Typography variant="h6">{ fNumber(total) }</Typography>
            </Box>
        </Card>
    );
}

Cards.propTypes = {
    icon: PropTypes.string,
    color: PropTypes.string,
    chart: PropTypes.object,
    percent: PropTypes.number,
    sx: PropTypes.object,
    title: PropTypes.string,
    total: PropTypes.number,
};
